import { orderDetailsPageStyles } from "@insite/content-library/Pages/OrderDetailsPage";
import { css } from "styled-components";

orderDetailsPageStyles.loadFailedWrapper = {
    css: css`
        display: flex;
        height: 200px;
        justify-content: center;
        align-items: center;
        background-color: none;
    `,
};
